var _defs, _metadata, _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _g3, _rect2, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2195 1776",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str1 {stroke:black;stroke-width:5.6836}\r\n    .str0 {stroke:black;stroke-width:50.1237}\r\n    .str2 {stroke:black;stroke-width:50.1237;stroke-linecap:round;stroke-linejoin:round}\r\n    .fil0 {fill:none}\r\n    .fil2 {fill:black}\r\n    .fil1 {fill:#F2C2CA}\r\n    .fil4 {fill:white}\r\n    .fil3 {fill:white;fill-rule:nonzero}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1098 332c-71,-2 -479,14 -713,518 -284,612 247,687 713,687 465,-1 996,-74 712,-687 -234,-504 -642,-520 -712,-518z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_211457440"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 2195,
    height: 1776
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M438 828c0,0 -92,-209 -120,-365 -22,-121 17,-195 29,-212 13,-20 113,-10 211,42 95,51 188,144 216,171l-336 364z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M1763 828c0,0 92,-209 120,-365 22,-121 -17,-195 -29,-212 -13,-20 -113,-10 -210,42 -96,51 -189,144 -216,171l335 364z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M511 701l159 -181c0,0 -155,-124 -212,-115 -56,9 14,202 53,296z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1690 701l-159 -181c0,0 155,-124 212,-115 56,9 -14,202 -53,296z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1098 332c-71,-2 -479,14 -713,518 -284,612 247,687 713,687 465,-1 996,-74 712,-687 -234,-504 -642,-520 -712,-518z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "fil0 str1",
    x: 125,
    y: 439,
    width: 138,
    height: 114
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M1098 332c-71,-2 -479,14 -713,518 -284,612 247,687 713,687 465,-1 996,-74 712,-687 -234,-504 -642,-520 -712,-518z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M967 1031l-100 0 0 0 0 -4 0 -5 -1 -4 -1 -4 0 -5 -1 -4 -2 -4 -1 -4 -2 -4 -1 -3 -2 -4 -2 -3 -2 -4 -3 -3 -2 -3 -3 -3 -2 -2 -3 -3 -3 -2 -2 -2 -3 -3 -3 -1 -3 -2 -4 -2 -3 -1 -3 -1 -3 -1 -3 -1 -4 -1 -3 0 -4 0 -3 -1 0 -100 9 0 9 1 9 1 8 2 9 2 8 3 8 3 8 3 8 4 8 4 7 5 7 5 7 5 6 6 6 6 6 6 6 6 5 7 5 7 5 7 4 8 4 7 4 8 3 8 3 8 3 9 2 8 2 9 1 9 1 9 1 9 0 9 0 0zm-172 185l0 -101 0 0 3 0 4 0 3 -1 4 0 3 -1 3 -1 3 -1 3 -2 4 -1 3 -2 3 -2 3 -2 2 -2 3 -2 3 -3 2 -3 3 -2 2 -4 3 -3 2 -3 2 -3 2 -4 1 -4 2 -3 1 -4 2 -4 1 -5 0 -4 1 -4 1 -5 0 -4 0 -5 100 0 0 10 -1 9 -1 9 -1 9 -2 8 -2 9 -3 8 -3 9 -3 8 -4 8 -4 7 -4 8 -5 7 -5 7 -5 7 -6 6 -6 6 -6 6 -6 6 -7 5 -7 5 -7 4 -8 5 -8 3 -8 4 -8 3 -8 3 -9 2 -8 1 -9 2 -9 0 -9 1 0 0zm-172 -185l100 0 0 0 0 5 0 4 1 5 0 4 1 4 1 5 2 4 1 4 2 3 1 4 2 4 2 3 2 3 3 3 2 4 2 2 3 3 3 3 2 2 3 2 3 2 3 2 3 2 3 1 3 2 4 1 3 1 3 1 4 0 3 1 3 0 4 0 0 101 -9 -1 -9 0 -9 -2 -9 -1 -8 -2 -9 -3 -8 -3 -8 -4 -7 -3 -8 -5 -7 -4 -7 -5 -7 -5 -6 -6 -6 -6 -6 -6 -6 -6 -5 -7 -5 -7 -5 -7 -4 -8 -4 -7 -4 -8 -3 -8 -3 -9 -3 -8 -2 -9 -2 -8 -1 -9 -1 -9 -1 -9 0 -10 0 0zm172 -184l0 100 0 0 -4 1 -3 0 -3 0 -4 1 -3 1 -3 1 -4 1 -3 1 -3 2 -3 2 -3 1 -3 3 -3 2 -2 2 -3 3 -3 2 -2 3 -2 3 -3 3 -2 4 -2 3 -2 4 -1 3 -2 4 -1 4 -2 4 -1 4 -1 5 0 4 -1 4 0 5 0 4 -100 0 0 -9 1 -9 1 -9 1 -9 2 -9 2 -8 3 -9 3 -8 3 -8 4 -8 4 -7 4 -8 5 -7 5 -7 5 -7 6 -6 6 -6 6 -6 6 -6 7 -5 7 -5 7 -5 8 -4 7 -4 8 -3 8 -3 9 -3 8 -2 9 -2 9 -1 9 -1 9 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M795 897c67,0 122,60 122,134 0,74 -55,134 -122,134 -68,0 -122,-60 -122,-134 0,-74 54,-134 122,-134z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 829,
    cy: 1033,
    r: 111
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil3",
    d: "M1228 1031l0 0 1 -9 0 -9 1 -9 2 -9 2 -9 2 -8 2 -9 3 -8 4 -8 3 -8 4 -7 5 -8 4 -7 5 -7 6 -7 5 -6 6 -6 6 -6 7 -6 6 -5 7 -5 8 -5 7 -4 8 -4 8 -3 8 -3 8 -3 9 -2 9 -2 8 -1 9 -1 9 0 0 100 -3 1 -4 0 -3 0 -3 1 -4 1 -3 1 -3 1 -3 1 -3 2 -3 2 -3 1 -3 3 -3 2 -3 2 -2 3 -3 2 -3 3 -2 3 -2 3 -2 4 -2 3 -2 4 -2 3 -2 4 -1 4 -1 4 -1 4 -1 5 -1 4 0 4 -1 5 0 4 0 0 -100 0zm172 185l0 0 -9 -1 -9 0 -8 -2 -9 -1 -9 -2 -8 -3 -8 -3 -8 -4 -8 -3 -7 -5 -8 -4 -7 -5 -6 -5 -7 -6 -6 -6 -6 -6 -5 -6 -6 -7 -5 -7 -4 -7 -5 -8 -4 -7 -3 -8 -4 -8 -3 -9 -2 -8 -2 -9 -2 -8 -2 -9 -1 -9 0 -9 -1 -10 100 0 0 5 1 4 0 5 1 4 1 4 1 5 1 4 1 4 2 3 2 4 2 4 2 3 2 3 2 3 2 4 3 2 3 3 2 3 3 2 3 2 3 2 3 2 3 2 3 1 3 2 3 1 3 1 4 1 3 0 3 1 4 0 3 0 0 0 0 101zm173 -185l0 0 -1 10 0 9 -1 9 -2 9 -2 8 -2 9 -2 8 -3 9 -4 8 -3 8 -4 7 -5 8 -4 7 -5 7 -6 7 -5 6 -6 6 -6 6 -7 6 -7 5 -7 5 -7 4 -7 5 -8 3 -8 4 -8 3 -8 3 -9 2 -9 1 -9 2 -8 0 -10 1 0 -101 4 0 3 0 4 -1 3 0 3 -1 4 -1 3 -1 3 -2 3 -1 3 -2 3 -2 3 -2 3 -2 3 -2 2 -3 3 -3 2 -2 3 -4 2 -3 2 -3 2 -3 2 -4 2 -4 1 -3 2 -4 1 -4 1 -5 1 -4 1 -4 0 -5 1 -4 0 -5 0 0 100 0zm-173 -184l0 0 10 0 8 1 9 1 9 2 9 2 8 3 8 3 8 3 8 4 7 4 7 5 7 5 7 5 7 6 6 6 6 6 5 6 6 7 5 7 4 7 5 8 4 7 3 8 4 8 3 8 2 9 2 8 2 9 2 9 1 9 0 9 1 9 -100 0 0 -4 -1 -5 0 -4 -1 -4 -1 -5 -1 -4 -1 -4 -2 -4 -1 -4 -2 -3 -2 -4 -2 -3 -2 -4 -2 -3 -3 -3 -2 -3 -3 -2 -2 -3 -3 -2 -3 -2 -3 -3 -3 -1 -3 -2 -3 -2 -3 -1 -3 -1 -4 -1 -3 -1 -3 -1 -4 0 -3 0 -4 -1 0 0 0 -100z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M1400 897c-67,0 -122,60 -122,134 0,74 55,134 122,134 68,0 123,-60 123,-134 0,-74 -55,-134 -123,-134z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "fil2",
    cx: 1367,
    cy: 1033,
    r: 111
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_211458112"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 1334,
    cy: 1033,
    r: 43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 862,
    cy: 1033,
    r: 43
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "fil1 str0",
    x: 884,
    y: 1083,
    width: 428,
    height: 332,
    rx: 82,
    ry: 109
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_211457872"
  }, /*#__PURE__*/React.createElement("line", {
    className: "fil0 str2",
    x1: 1018,
    y1: 1301,
    x2: 1018,
    y2: 1198
  }), /*#__PURE__*/React.createElement("line", {
    className: "fil0 str2",
    x1: 1177,
    y1: 1301,
    x2: 1177,
    y2: 1198
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni13);
export default __webpack_public_path__ + "static/media/ani13.f78936c923d4910155bb18f0eab90c8d.svg";
export { ForwardRef as ReactComponent };